import {
	EVENT_ACTION_ADD_VEHICLE,
	EVENT_CATEGORY_VEHICLE_MANAGEMENT,
	trackCustomEvent,
} from '../../../../shared/analytics';

export function trackAddVehicle(screen: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_VEHICLE_MANAGEMENT,
		action: EVENT_ACTION_ADD_VEHICLE,
		screenName: screen,
	});
}
